import React from 'react';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import classNames from 'classnames';

export const PaymentPlanPoint = ({ description, isAvailable }) => {
  return (
    <div className="flex items-center gap-1">
      {isAvailable ? (
        <DoneRoundedIcon className="h-4 w-4 text-[#028A12]" />
      ) : (
        <CloseRoundedIcon className="h-4 w-4 text-[#B3011D]" />
      )}
      <span className={classNames(
        "text-base leading-21",
        isAvailable ? 'text-[#191919]' : 'text-[#989898]'
      )}>{description}</span>
    </div>
  );
};
